module.exports = __webpack_public_path__ + "static/so-2-2f8c2695010d96debdf9ca0629cd0930.png";